import React from "react";
import { Tabs } from "antd";
import { Locale } from "../../utils";
import SpecialShareTransfers from "./SpecialShareTransfers";
import SpecialShareParties from "./SpecialShareParties";

const i18n = Locale.getInstance();

function SpecialShareList() {
  return (
    <Tabs
      defaultActiveKey="parties"
      items={[
        {
          key: "parties",
          label: i18n.t("specialShareParties.tab"),
          children: <SpecialShareParties />,
        },
        {
          key: "transfers",
          label: i18n.t("specialShareList.tab"),
          children: <SpecialShareTransfers />,
        },
      ]}
    />
  );
}

export default SpecialShareList;
